import { render, staticRenderFns } from "./PrescriptionHistory.vue?vue&type=template&id=43ae32a5&scoped=true&lang=pug"
import script from "./PrescriptionHistory.vue?vue&type=script&lang=js"
export * from "./PrescriptionHistory.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionHistory.vue?vue&type=style&index=0&id=43ae32a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae32a5",
  null
  
)

export default component.exports